import React, { useMemo } from 'react';

import { ia } from 'lib/helpers/utility';

import Typography from 'components/shared/Typography/Typography';

import ReceiptTable from '../ReceiptTable/ReceiptTable';

import ReceiptTransactionsTableMobile from './ReceiptTransactionsTableMobile';
import { TRANSACTIONS_TABLE_COLUMNS } from './columnDefs';

const ReceiptTransactions = ({ transactions, timezone }) => {
  const columns = useMemo(() => {
    return TRANSACTIONS_TABLE_COLUMNS(timezone);
  }, [timezone]);

  if (!ia(transactions)) return null;

  return (
    <div className="flex flex-col gap-3 px-2 md:px-6">
      <Typography variant="p" size="small" weight="medium" color="neutral-500">
        Payment History
      </Typography>

      <ReceiptTable items={transactions} columns={columns} />
      <ReceiptTransactionsTableMobile transactions={transactions} timezone={timezone} />
    </div>
  );
};

export default ReceiptTransactions;
